import { FEATURES, IN_ROOM } from 'consts';
import { useUserSettingsContext } from 'contexts';
import { isFeatureOn } from 'useCase/featureFlags/featureFlagsApi';
import { VcsSipControllerService } from 'api';
import { selectRoomId } from 'state/selectors';

interface UseSIPTelephonyResult {
    isSIPOn(): boolean;
    addSIPParticipant(phone: string): Promise<void>;
    prepareSIPConnect(): void;
}

export const useSIPTelephony = (): UseSIPTelephonyResult => {
    const { setAudioEnabled, setVideoEnabled } = useUserSettingsContext();

    const isSIPOn = () => {
        return isFeatureOn(FEATURES.SIP_ENABLED);
    };

    const addSIPParticipant = async (phone: string) => {
        const roomId = selectRoomId();
        const { error, payload } = await VcsSipControllerService.join({
            roomId,
            sipPhone: phone,
        });

        if (payload) {
            console.log('Участник подключён');
        }
        if (error) {
            console.log('Ошибка при подключении участника');
        }
    };

    const prepareSIPConnect = () => {
        if (!isSIPOn()) return;

        sessionStorage.setItem(IN_ROOM, '1');
        setAudioEnabled(false);
        setVideoEnabled(false);
    };

    return {
        isSIPOn,
        addSIPParticipant,
        prepareSIPConnect,
    };
};
